// import React, { useEffect, useState } from 'react';
// import {
//   TextField,
//   MenuItem,
//   InputAdornment,
//   IconButton,
//   Box,
//   Grid,
//   Typography,
//   FormControl,
//   Select,
//   Button
// } from '@mui/material';
// import { Edit, Check, Send } from '@mui/icons-material';

// const emailOptions = [
//     'hotresume@jobsnprofiles.ai',
//     'hotresume@jobsnprofiles.net',
//     'noreply@jobsnprofiles.net',
//     'noreply@jobsnprofiles.ai',
//     'alerts@jobsnprofiles.net',
//     'alerts@jobsnprofiles.ai',
//   ];

// const LiveJobsManualMailForm = ({handleSendMail, setData, data}) => {
//   const [formData, setFormData] = useState({
//     fromEmail: emailOptions[0],
//     recruiterName: '',
//     toEmail: data.toEMail
//   });
//   const [editMode, setEditMode] = useState(false);

//   useEffect(() => {
//     setFormData(prevData => ({
//         ...prevData,
//         recruiterName: data.fullname,
//         toEMail: data.toEMail,
//     }))
//   }, [data])

//   const handleChange = (e) => {
//     setFormData({ ...formData, [e.target.name]: e.target.value });
//   };

//   const toggleEdit = () => setEditMode(!editMode);

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     console.log('Form submitted:', formData);
//     // Add your mail sending logic here
//     handleSendMail();
//     alert(`Email will be sent from ${formData.fromEmail} to ${formData.toEmail}`);
//   };

//   return (
//     <Box
//       component="form"
//       onSubmit={handleSubmit}
//       sx={{ maxWidth: 800, mx: 'auto', p: 3 }}
//     >
//       <Typography variant="h6" gutterBottom sx={{ mb: 3 }}>
//         Email Details
//       </Typography>

//       <Grid container spacing={2}>
//         {/* 1. From Email (Select Dropdown) */}
//         <Grid item xs={12} sm={6} md={3}>
//           <FormControl fullWidth>
//             <Select
//               name="fromEmail"
//               value={formData.fromEmail}
//               onChange={handleChange}
//               displayEmpty
//               required
//               size='small'
//             >
//               <MenuItem value="" disabled>
//                 Select from email
//               </MenuItem>
//               {emailOptions.map((email) => (
//                 <MenuItem key={email} value={email}>
//                   {email}
//                 </MenuItem>
//               ))}
//             </Select>
//           </FormControl>
//         </Grid>

//         {/* 2. To Email (with edit toggle) */}
//         <Grid item xs={12} sm={12} md={3}>
//           <TextField
//             fullWidth
//             label="To Email"
//             name="toEmail"
//             value={formData.toEmail}
//             onChange={handleChange}
//             disabled={!editMode}
//             size='small'
//             InputProps={{
//               endAdornment: (
//                 <InputAdornment position="end" >
//                   <IconButton onClick={toggleEdit}>
//                     {editMode ? <Check color="primary" /> : <Edit />}
//                   </IconButton>
//                 </InputAdornment>
//               ),
//             }}
//           />
//         </Grid>
//         {/* 3. Recruiter Name */}
//         <Grid item xs={12} sm={6} md={3.5}>
//           <TextField
//             fullWidth
//             label="Recruiter Name"
//             name="recruiterName"
//             value={formData.recruiterName}
//             onChange={handleChange}
//             required
//             size='small'
//           />
//         </Grid>

//         {/* Send Mail Button */}
//         <Grid item xs={12} sm={12} md={2.5} sx={{ display: 'flex', justifyContent: 'flex-end',  }}>
//           <Button
//             variant="contained"
//             color="primary"
//             type="submit"
//             startIcon={<Send />}
//             sx={{
//               px: 4,
//               py: 1,
//               borderRadius: '4px',
//               textTransform: 'none',
//               fontSize: '0.875rem'
//             }}
//           >
//             Send Mail
//           </Button>
//         </Grid>
//       </Grid>
//     </Box>
//   );
// };

// export default LiveJobsManualMailForm;

import React, { useEffect, useState } from 'react';
import {
  TextField,
  MenuItem,
  InputAdornment,
  IconButton,
  Box,
  Grid,
  Typography,
  FormControl,
  Select,
  Button,
  Chip,
  Stack,
  Autocomplete,
} from '@mui/material';
import { Edit, Check, Send, Close } from '@mui/icons-material';
import { toast } from 'react-toastify';
import Key from '../clientVariables.json';

const emailOptions = [
  // 'hotresume@jobsnprofiles.ai',
  // 'hotresume@jobsnprofiles.net',
  'alerts@jobsnprofiles.ai',
  'alerts@jobsnprofiles.net',
  'noreply@jobsnprofiles.net',
  'noreply@jobsnprofiles.ai',
];

const LiveJobsManualMailForm = ({ selectedResumes, data, resumeIds }) => {
  const [formData, setFormData] = useState({
    fromEmail: emailOptions[0],
    recruiterName: '',
    toEmail: '',
    ccEmails: [],
  });
  const [editMode, setEditMode] = useState(false);
  const [ccInput, setCcInput] = useState('');

  const [buttonLoading, setButtonLoading] = useState(false);

  useEffect(() => {
    // console.log(data);

    if (data) {
      setFormData((prevData) => ({
        ...prevData,
        recruiterName: data?.contact_name || '',
        toEmail: data?.contact_email || '',
      }));
    }
  }, [data]);

  useEffect(() => {
    setButtonLoading(false);
  }, [selectedResumes])

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const toggleEdit = () => setEditMode(!editMode);

  const handleAddCc = () => {
    if (ccInput && !formData.ccEmails.includes(ccInput)) {
      setFormData({
        ...formData,
        ccEmails: [...formData.ccEmails, ccInput],
      });
      setCcInput('');
    }
  };

  const handleDeleteCc = (emailToDelete) => {
    setFormData({
      ...formData,
      ccEmails: formData.ccEmails.filter((email) => email !== emailToDelete),
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setButtonLoading(true);
    const mailData = {
      ...formData,
    };
    console.log('Form submitted:', mailData);
    handleSendMail(mailData);
  };
  const handleSendMail = (mailData) => {
    const { toEmail, fromEmail, recruiterName, ccEmails } = mailData;
    console.log(mailData);
    console.log(selectedResumes);
    if (toEmail && fromEmail && recruiterName) {
      console.log(selectedResumes);
      if (selectedResumes.length > 8) {
        console.log('Maximum limit to share resumes is 5');
        const msg = 'Maximum limit to share resumes is 5';
        toast.error(msg);
      } else if (selectedResumes.length > 0) {
        console.log('mail data------------', mailData, selectedResumes);

        // {
        //   fromEmail: 'hotresume@jobsnprofiles.ai',
        //   recruiterName: 'Demo Emp',
        //   toEmail: 'demoemp@jobsnprofiles.com',
        //   ccEmails: [ 'sherry@jobsnprofiles.com' ],
        //   toUserId: undefined,
        //   jobId: undefined
        // }
        const formData = {
          fromEmail,
          fullname: recruiterName,
          toEMail: toEmail,
          ccEMail: ccEmails,
          subj: '',
          body: '',
          jobtitle: data?.application_title,
          skillname: '',
          location: '',
          toUserId: data?.user_id,
          jobId: data?.id,
          mailBodyCondition: '',
        };

        // const resumeIds = selectedResumes?.filter((data) => data.id);
console.log(resumeIds);
        // Uncomment this for actual send logic

        fetch(`${Key.domain}/common/send_livejob_resumes_mail`, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            formdata: formData,
            resumedata: selectedResumes,
          }),
        })
          .then((response) => response.json())
          .then((resdata) => {
            if (resdata.data === "Mail sent") {
                fetch(`${Key.domain}/customer/save_suggested_resumes_mail`, {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        admin_id: sessionStorage.getItem("id"),
                        session_token: sessionStorage.getItem('userToken'),
                        jobid: data?.id,
                        fromUserMail: fromEmail,
                        fromUserId: sessionStorage.getItem("id"),
                        toUserMail: toEmail,
                        toUserId: data?.user_id,
                        sharedResumeIds: resumeIds
                    }),
                }).then(() => {
                    const msg = "Mail Sent Successfully";
                    setButtonLoading(true);
                    toast.success(msg);
                    window.location.reload();
                });
            }
          });
      } else {
        const msg = 'Select at least 1 resume';
        toast.warning(msg);
      }
    }
  };

  return (
    <Box component="form" onSubmit={handleSubmit} sx={{ maxWidth: 800, mx: 'auto', p: 3 }}>
      <Typography variant="h6" gutterBottom sx={{ mb: 3 }}>
        Email Details
      </Typography>

      <Grid container spacing={2}>
        {/* From Email */}
        <Grid item xs={12} sm={6} md={3}>
          <FormControl fullWidth>
            <Select name="fromEmail" value={formData.fromEmail} onChange={handleChange} required size="small">
              {emailOptions.map((email) => (
                <MenuItem key={email} value={email}>
                  {email}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>

        {/* To Email */}
        <Grid item xs={12} sm={6} md={3}>
          <TextField
            fullWidth
            label="To Email"
            name="toEmail"
            value={formData.toEmail}
            onChange={handleChange}
            disabled={!editMode}
            size="small"
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton onClick={toggleEdit}>{editMode ? <Check color="primary" /> : <Edit />}</IconButton>
                </InputAdornment>
              ),
            }}
          />
        </Grid>

        {/* Recruiter Name */}
        <Grid item xs={12} sm={6} md={3}>
          <TextField
            fullWidth
            label="Recruiter Name"
            name="recruiterName"
            value={formData.recruiterName}
            onChange={handleChange}
            required
            size="small"
          />
        </Grid>

        {/* Send Button */}
        <Grid item xs={12} sm={6} md={3}>
          <Button
            fullWidth
            variant="contained"
            color="primary"
            type="submit"
            startIcon={<Send />}
            disabled={buttonLoading}
            sx={{
              height: '40px',
              textTransform: 'none',
            }}
          >
            Send Mail
          </Button>
        </Grid>

        {/* CC Emails */}
        <Grid item xs={12} sm={6} md={3}>
          <Stack spacing={1}>
            <Box sx={{ display: 'flex', gap: 1 }}>
              <TextField
                fullWidth
                label="CC Emails"
                value={ccInput}
                onChange={(e) => setCcInput(e.target.value)}
                size="small"
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    e.preventDefault(); // Prevent form submission
                    handleAddCc(); // Add the CC email
                  }
                }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton onClick={handleAddCc} disabled={!ccInput} size="small">
                        <Check />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </Box>
          </Stack>
        </Grid>
        <Grid item xs={9}>
          {formData.ccEmails.length > 0 && (
            <Stack direction="row" spacing={1} sx={{ flexWrap: 'wrap', gap: 1 }}>
              {formData.ccEmails.map((email) => (
                <Chip
                  key={email}
                  label={email}
                  onDelete={() => handleDeleteCc(email)}
                  deleteIcon={<Close />}
                  size="small"
                  variant="outlined"
                />
              ))}
            </Stack>
          )}
        </Grid>
      </Grid>
    </Box>
  );
};

export default LiveJobsManualMailForm;
